function normalizeBaseUrl(url) {
  if (!url) {
    return "";
  }

  return url.replace(/\/+$/, "");
}

export const API_BASE_URL = normalizeBaseUrl(process.env.VUE_APP_API_BASE_URL);
